import '../ActivityActions.scss';
import React from 'react';
import { useForm } from 'react-hook-form';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import TextareaControl from '@srm/ui/controls/TextareaControl';
import { stringifyError } from '@srm/core/errors';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';
import { ITakeToWorkProps } from './ITakeToWorkProps';

interface ITakeToWorkFormData {
    comment?: string;
}

export const TakeToWorkModal: React.FC<ITakeToWorkProps> = (props: ITakeToWorkProps) => {
    const formMethods = useForm<ITakeToWorkFormData>({ mode: 'onBlur' });
    const hasUnsavedInput = useUnsavedFormInput(formMethods, { textFields: ['comment'] });

    const { errorText, isBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: false,
        resetErrorOnSubmit: true,
        mapError: stringifyError,
        submit: (form: ITakeToWorkFormData) =>
            new ActivityExecutionService().takeToWork(
                props.actionKey,
                props.objId,
                props.hideComment ? '' : (form.comment ?? ''),
            ),
        onSuccess: (x) => {
            if (x.status == 200 && props?.completeHandler) props.completeHandler(true);
        },
    });

    const modalContainerProps: IModalContainerProps = {
        header: 'Взять в работу',
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput,
        errorText: errorText,
        formMethods: formMethods,
        onSubmit: okClick,
        onCancel: cancelClick,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            {!props.hideComment && (
                <TextareaControl name="comment" label="Комментарий" rows={6} control={formMethods.control} />
            )}
        </ModalContainer>
    );
};
